import { v4 as uuidv4 } from 'uuid';

interface ApiRequestConfig {
  data?: any;
  headers?: Record<string, string>;
  method?: string;
  signal?: AbortSignal;
  url: string;
}

export const guestIdParamLocalStorage = 'fc_guest_session_id';

export const checkOrDefineSessionId = () => {
  if (!window.localStorage.getItem(guestIdParamLocalStorage)) {
    const newGuestId = `${Date.now()}${uuidv4()}`;
    window.localStorage.setItem(guestIdParamLocalStorage, newGuestId);
  }
};

export const removeUnused = (params: any = {}) => {
  const outParams: any = {};
  Object.keys(params).forEach((k) => {
    if (Array.isArray(params[k])) {
      outParams[k] = params[k].map((elm: any) => removeUnused(elm));
    } else if (typeof params[k] === 'object') {
      outParams[k] = removeUnused(params[k]);
    } else if (
      typeof params[k] === 'boolean' ||
      typeof params[k] === 'number' ||
      params[k]
    ) {
      outParams[k] = params[k];
    }
  });
  return outParams;
};

export const apiCall = async <T>(config: ApiRequestConfig): Promise<T> => {
  const response = await fetch(config.url, {
    body: JSON.stringify(config.data),
    headers: {
      ...(config.headers || {}),
      'Content-Type': 'application/json',
      'Strict-Transport-Security':
        process.env.REACT_APP_TARGET_BUILD === 'demo' ? '' : 'max-age=86400'
    },
    method: config.method ?? 'GET',
    signal: config.signal
  });

  if (!response.ok || response.status !== 200) {
    const err: any = new Error(`HTTP error! Status: ${response.status}`);
    err.response = await response.json();
    throw err;
  }

  return response.json();
};
